import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { withAutomationsCategory } from './automationsAnalytics';
import META from './useTrackAutomationEnabledChanged.meta';

export type UseTrackAutomationEnabledChangedParams = {
  automation_id: string;
  enabled: boolean;
};

export const useTrackAutomationEnabledChanged = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationEnabledChanged = useCallback(
    (params: UseTrackAutomationEnabledChangedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationEnabledChanged };
};
